<template>
  <v-container fluid fill-height style="min-height: calc(100vh - 70px - 84px);">
    <notifications class="pa-3"/>
    <v-row justify="center">
      <v-col cols="12" md="12" class="align-self-center">
        <v-card outlined rounded="lg" color="transparent">
          <v-card-text>
            <div class="text-center">
              <v-progress-circular
                v-if="loading.unit"
                :width="3"
                color="red"
                indeterminate>
              </v-progress-circular>
            </div>
            <div v-if="!loading.unit">
              <v-row v-if="!dataunit.length">
                <v-col cols="12" md="6" offset-md="3">
                  <v-alert
                    border="top"
                    colored-border
                    type="warning"
                    elevation="2">
                    <v-row align="center">
                      <v-col class="grow py-0">
                        <b>Data unit tidak ditemukan</b><br>
                        Jika pilihan tidak muncul, mohon segera menghubungi administrator aplikasi!
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row class="black--text" v-if="dataunit.length">
                <v-col cols="12" class="mb-3 text-center">
                  <h1 class="text-md-h4 mb-1">
                    {{ dataunit.length ? dataunit[0].nama_unit : '' }}
                  </h1>
                  <div>
                    <v-rating
                      class="mb-1"
                      v-model="ratingunit"
                      color="yellow accent-4"
                      dense
                      half-increments
                      size="32"
                      readonly
                      :length="nilaimax">
                    </v-rating>
                    <span class="text-subtitle-1">
                      Today Rating: <b>{{ ratingunit }}</b>/{{ nilaimax }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" class="text-center">
                  <h2 class="text-md-h5">
                    Bagaimana kepuasan Anda terhadap pelayanan kami ?
                  </h2>
                </v-col>
                <v-col cols="12" md="10" offset-md="1" v-if="alertdata.show">
                  <alertsp :alertdata="alertdata"></alertsp>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-progress-circular
                    v-if="loading.survey"
                    :width="3"
                    color="red"
                    indeterminate>
                  </v-progress-circular>
                  <v-row class="font-weight-bold" justify="center" v-if="!loading.survey">
                    <v-col cols="6" sm="4" md="2">
                      <div @click="cekSurvey(1)" class="style-pointer">
                        <v-icon size="80" color="red accent-4">
                          mdi-emoticon-angry-outline
                        </v-icon>
                        <p class="text-md-h6 mb-0">
                          Tidak Puas
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="4" md="2">
                      <div @click="cekSurvey(2)" class="style-pointer">
                        <v-icon size="80" color="deep-orange darken-1">
                          mdi-emoticon-sad-outline
                        </v-icon>
                        <p class="text-md-h6 mb-0">
                          Kurang Puas
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="4" md="2">
                      <div @click="cekSurvey(3)" class="style-pointer">
                        <v-icon size="80" color="orange">
                          mdi-emoticon-neutral-outline
                        </v-icon>
                        <p class="text-md-h6 mb-0">
                          Cukup Puas
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="4" md="2">
                      <div @click="cekSurvey(4)" class="style-pointer">
                        <v-icon size="80" color="lime darken-4">
                          mdi-emoticon-happy-outline
                        </v-icon>
                        <p class="text-md-h6 mb-0">
                          Puas
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="4" md="2">
                      <div @click="cekSurvey(5)" class="style-pointer">
                        <v-icon size="80" color="green darken-4">
                          mdi-emoticon-excited-outline
                        </v-icon>
                        <p class="text-md-h6 mb-0">
                          Sangat Puas
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- modal loading -->
    <v-dialog
      v-model="dmodal.loading"
      persistent
      width="300">
      <v-card>
        <v-card-text class="pt-6">
          <div v-if="loading.survey">
            Please stand by
            <v-progress-linear
              indeterminate>
            </v-progress-linear>
          </div>
          <div v-if="dmodal.image" class="text-center">
            <img :src="require('../../assets/suksma.png')" width="120"/>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- modal select unit -->
    <v-dialog
      v-model="dmodal.unit"
      persistent
      width="600px">
      <v-card>
        <v-card-text class="pt-6">
          <v-container>
            <div v-if="loading.unitlist" class="text-center">
              <v-progress-circular
                :width="3"
                color="red"
                indeterminate>
              </v-progress-circular>
            </div>
            <v-row v-if="!loading.unitlist">
              <v-col cols="12" md="12">
                <alertsp :alertdata="alertdatalist"></alertsp>
                <span class="font-weight-bold text-subtitle-1">
                  Pilih salah satu daftar unit sebagi obyek survey.
                </span>
              </v-col>
              <v-col cols="12" md="9">
                <v-autocomplete
                  v-model="unitput"
                  :items="listunit"
                  item-text="nama_unit"
                  label="Daftar unit"
                  name="unitlist"
                  :rules="[rules.required]"
                  return-object>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  class="mt-1"
                  color="primary"
                  large
                  block
                  @click="doSelectUnit()">
                  Pilih
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- modal feedback -->
    <v-dialog
      v-model="dmodal.feed"
      persistent
      width="600px">
      <v-card>
        <v-card-text class="pt-6">
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-form
                  @submit.prevent="doSurvey"
                  ref="formlogin"
                  v-model="formin.valid">
                  <v-textarea
                    v-model="feedback"
                    name="infeedback"
                    filled
                    label="Saran atau masukan *"
                    auto-grow
                    autofocus
                    :rules="[rules.required]">
                  </v-textarea>
                  <v-btn
                    class="mr-1"
                    color="error"
                    large
                    @click="dmodal.feed = false">
                    Batal
                  </v-btn>
                  <v-btn
                    type="submit"
                    color="primary"
                    large
                    :loading="loading.survey"
                    :disabled="loading.survey || !formin.valid">
                    Simpan
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import thankSound from '@/assets/thankyou.mp3';

export default {
  name: 'Feedback',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdatalist: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      unitlist: false,
      unit: false,
      survey: false,
      login: false,
      regnew: false,
      feed: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    unit: '',
    dataunit: [],
    ratingunit: 0,
    login: {
      email: '',
      password: '',
      remember: true,
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => ((!!v && v.length >= 16) || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    dmodal: {
      register: false,
      loading: false,
      image: false,
      unit: false,
      feed: false,
    },
    thankSound,
    listunit: [],
    unitput: null,
    nilaimax: 5,
    feedback: '',
    nilaitemp: 1,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'selectunit',
    ]),
  },
  created: () => ({
  }),
  mounted() {
    if (!this.selectunit || this.selectunit.length <= 0) {
      // select unit
      this.getUnitList();
      this.formSelectUnit(true);
    } else {
      // get detail unit
      this.getUnit();
    }
    // this.dmodal.loading = true;
    // this.dmodal.image = true;
    // this.loading.survey = true;
  },
  methods: {
    redirectDetail(direction, delay) {
      const thisVue = this;
      setTimeout(() => (thisVue.$router.push(direction)), delay);
    },
    doSelectUnit() {
      if (this.unitput) {
        // console.log(this.unitput);
        this.$store.commit('SELECT_UNIT', this.unitput);
        this.formSelectUnit(false);
        this.getUnit();
      }
    },
    formSelectUnit(show) {
      this.dmodal.unit = show;
    },
    getUnitList() {
      this.alertdatalist.show = false;
      this.loading.unitlist = true;
      this.axios
        .get(
          this.api + '/public/unit',
          {
            params: [],
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              this.listunit = resdata.data;
              this.unitput = this.listunit[0];
            } else {
              this.alertdatalist.show = true;
              this.alertdatalist.type = 'error';
              this.alertdatalist.text = resdata.message;
            }
          } else {
            this.alertdatalist.show = true;
            this.alertdatalist.type = 'error';
            this.alertdatalist.text = 'Internal services error!';
          }
          this.loading.unitlist = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading.unitlist = false;
          this.alertdatalist.show = true;
          this.alertdatalist.type = 'error';
          this.alertdatalist.text = 'Internal services error!';
        });
    },
    getUnit() {
      this.alertdata.show = false;
      if (this.selectunit.id_unit) {
        this.loading.unit = true;
        this.axios
          .get(
            this.api + '/public/unit/' + this.selectunit.id_unit,
            {
              params: [],
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dataunit = resdata.data;
                this.getRating();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.unit = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.unit = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Data unit tidak ditemukan!';
      }
    },
    getRating() {
      this.alertdata.show = false;
      if (this.selectunit.id_unit) {
        this.loading.unit = true;
        this.axios
          .get(
            this.api + '/public/unit/rating/' + this.selectunit.id_unit,
            {
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.ratingunit = Number(resdata.data[0].rating);
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.unit = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.unit = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Data unit tidak ditemukan!';
      }
    },
    cekSurvey(nilai) {
      this.feedback = '';
      if (nilai > 0 && nilai <= this.nilaimax && this.selectunit.id_unit) {
        this.nilaitemp = nilai;
        if (nilai < 4) {
          // show form
          this.dmodal.feed = true;
        } else {
          // submit survey
          this.doSurvey();
          // this.$notify(notifdata);
        }
      }
    },
    doSurvey() {
      // this.alertdata.show = false;
      const notifdata = {
        title: 'Notifikasi Feedback',
        text: '',
        type: 'warm',
      };
      this.dmodal.loading = true;
      this.dmodal.image = false;
      this.loading.survey = true;
      const datasur = {
        value: this.nilaitemp,
        unit: this.selectunit.id_unit,
        feed: this.feedback,
      };
      this.axios
        .post(
          this.api + '/public/survey',
          qs.stringify(
            datasur,
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              // close form feedback
              this.dmodal.feed = false;
              // show image
              this.loading.survey = false;
              this.dmodal.image = true;
              // play sound
              const note = new Audio(this.thankSound);
              setTimeout(() => {
                note.play();
              }, 500);
              // wait - 4 second - close
              setTimeout(() => {
                this.dmodal.loading = false;
                this.dmodal.image = false;
                this.redirectDetail({ name: 'Index' }, 1000);
              }, 4000);
              // notif
              notifdata.type = 'success';
              notifdata.text = 'Terimakasih untuk tanggapan yang diberikan!';
              // refresh rating
              this.getRating();
            } else {
              this.dmodal.loading = false;
              notifdata.type = 'error';
              notifdata.text = resdata.message;
            }
          } else {
            this.dmodal.loading = false;
            notifdata.type = 'error';
            notifdata.text = 'Internal services error!';
          }
          this.$notify(notifdata);
        })
        .catch((error) => {
          console.log(error);
          notifdata.type = 'error';
          notifdata.text = 'Internal services error!';
          this.$notify(notifdata);
          this.loading.survey = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $main-color: #216185;
  .style-pointer{
    border-radius: 15px;
    padding: 10px;
    cursor: pointer;
  }
  .style-pointer:hover{
    background-color: #EEEEEE;
  }
</style>
